<template>
  <div class="index_info">
    <div class="header_btn">
      <el-button type="primary" @click="clearConfig">清空配置</el-button>
      <el-button type="primary" @click="toggleRowExpansion(true)">一键展开</el-button>
      <el-button type="primary" @click="toggleRowExpansion(false)">一键收起</el-button>
    </div>
    <div class="city_ul">
      <el-table height="500" ref="topicTable" :data="areaTreeList" tooltip-effect="dark" style="width: 100%"
        row-key="id" default-expand-all :tree-props="{ children: 'subAreas' }">
        <el-table-column prop="areaName" label="省市"></el-table-column>
        <el-table-column align="center" label="库存">
          <template slot-scope="scope">
            <el-input v-model="scope.row.stockNum" @blur="inputHandle($event, scope.row)"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { KSAXApiRequest, skuAreaStockTreeList } from "../../../api/api";
export default {
  watch: {
    isSingleSpec(newVal, oldVal) {
      this.getSkuAreaStockTreeList();
    },
    areaStockIndex(newVal, oldVal) {
      this.editAreaList = [];
      this.editAreaList = this.value.skus[this.areaStockIndex].areaStocks;
      this.getSkuAreaStockTreeList();
    },
  },
  props: {
    value: {},
    isSingleSpec: false,
    areaStockIndex: 0,
    regStockSkuId: 0
  },
  data() {
    return {
      areaTreeList: [],
      editAreaList: [],
    };
  },
  created() {
    this.getSkuAreaStockTreeList();
    this.$nextTick(() => {
      this.editAreaList = this.value.skus[this.areaStockIndex].areaStocks;
    })
  },
  methods: {
    toggleRowExpansion(isExpansion) {
      this.toggleRowExpansion_forAll(this.areaTreeList, isExpansion);
    },
    toggleRowExpansion_forAll(data, isExpansion) {
      data.forEach(item => {
        this.$refs.topicTable.toggleRowExpansion(item, isExpansion);
        if (item.children != undefined && item.children != null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      })
    },
    getSkuAreaStockTreeList() {
      let that = this;
      console.log(that.regStockSkuId, 'that.regStockSkuId')
      let params = {
        path: 'Product_SkuAreaStock/SkuAreaStockTreeList',
        parms: `skuId=${that.regStockSkuId}`,
        parmsJson: null
      };
      KSAXApiRequest(params).then((res) => {
        that.areaTreeList = res.data.response;
        if (that.isSingleSpec && that.value.skus[0].areaStocks[0]) {
          that.value.skus[0].areaStocks.forEach((v, i) => {
            that.areaTreeList.forEach((v1, i1) => {
              if (v.areaId == v1.id) {
                v1.stockNum = v.stockNum;
              } else {
                v1.subAreas.forEach((v2, i2) => {
                  if (v.areaId == v2.id) {
                    v2.stockNum = v.stockNum;
                  }
                });
              }
            });
          });
        } else if (
          !that.isSingleSpec &&
          that.editAreaList &&
          that.editAreaList[0]
        ) {
          that.editAreaList.forEach((v, i) => {
            that.areaTreeList.forEach((v1, i1) => {
              if (v.areaId == v1.id) {
                v1.stockNum = v.stockNum;
              } else {
                v1.subAreas.forEach((v2, i2) => {
                  if (v.areaId == v2.id) {
                    v2.stockNum = v.stockNum;
                  }
                });
              }
            });
          });
        }
      });
    },
    inputHandle(e, row) {
      let that = this;
      if (that.editAreaList[0]) {
        that.editAreaList.forEach((v, i) => {
          if (v.areaId == row.id) {
            that.editAreaList.splice(i, 1);
          }
        });
      }
      that.editAreaList.push({
        id: row.skuAreaStockId,
        areaLevel: row.areaLevel,
        areaId: row.id,
        stockNum: row.stockNum,
      });
    },
    clearConfig() {
      let that = this;
      let list = that.areaTreeList;
      let elist = that.editAreaList;
      list.forEach((v) => {
        v.stockNum = null;
        if (v.subAreas) {
          v.subAreas.forEach((v1) => {
            v1.stockNum = null;
          });
        }
      });
      that.areaTreeList = list;
      elist.forEach((v) => {
        v.stockNum = null;
      });
      that.editAreaList = elist;
    },
    submitAreaData() {
      let that = this;
      let _list = [];
      that.editAreaList.forEach((v, i) => {
        if (v.stockNum >= 0 && v.stockNum !== "" && v.stockNum !== null) {
          _list.push(v);
        }
      });
      if (that.isSingleSpec) {
        that.value.skus[0].areaStocks = _list;
      } else {
        that.value.skus[that.areaStockIndex].areaStocks = _list;
      }
      that.$message.success("库存数据保存成功，提交后生效！");
    },
  },
};
</script>

<style scoped>
.index_info {
  border-top: 2px solid #eee;
}

.header_btn {
  padding: 20px;
}

.foot-btn {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 2px solid #eee;
}

.el-input {
  min-width: 100px;
  max-width: 200px;
}
</style>